/*
 * @Author: your name
 * @Date: 2021-01-19 12:14:20
 * @LastEditTime: 2021-09-02 10:01:31
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \lavrock-official-platform\src\router\sideNav\account.route.js
 */
const Main = () => import('../../pages/main')

const CompanyInfo = () => import('../../pages/AccountCenter/Company')
const AccountInfo = () => import('../../pages/AccountCenter/Account')
// 实名认证
const Certify = () => import('../../pages/Certify')


export default {
	path: '/regulate',
	component: Main,
	meta: {
		requiresAuth: true,
		hidden: false,
		title: '账户管理',
		icon: 'icon-nav icon-nav-account',
		sideNav: true
	},
	children: [
		{
			name: 'companyInfo',
			path: 'companyInfo',
			component: CompanyInfo,
			meta: {
				requiresAuth: true,
				hidden: false,
				title: '企业信息'
			}
		},
		{
			name: 'accountInfo',
			path: 'accountInfo',
			component: AccountInfo,
			meta: {
				requiresAuth: true,
				hidden: false,
				title: '账号信息'
			}
		},

		{
			name: 'certify',
			path: 'certify',
			component: () => import('../../pages/Certify'),
			meta: {
				requiresAuth: true,
				hidden: false,
				title: '实名认证'
			}
		}
	]
}
